module.exports = __webpack_public_path__ + "media/maintenance.6cf15e8f.svg";